import { IconButton } from "@/components/Buttons";
import CarouselItem from "@/components/Carousel/Item";
import CarouselModal from "@/components/Carousel/Modal";
import { Pressable, View } from "@/components/Theme";
import { useWindowStore } from '@/stores/useWindowStore';
import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import Swiper from "react-native-swiper";

const PrevButton = <IconButton icon={'chevron-left'} size={50} color={'white'} />;
const NextButton = <IconButton icon={'chevron-right'} size={50} color={'white'} />

const Carousel = forwardRef((props, ref) => {
    const activeIndexRef = useRef(0);
    const carouselRef = useRef(null);
    const modalRef = useRef(null);
    
    const {width: windowWidth, height: windowHeight} = useWindowStore((s) => s.dimensions);
    
    const {
        media = [], 
        actions, 
        showFirst = false,
        showGrid = false,
        thumbnailStyle = {},
        showPlus = false,
        showCounter = false,
        showThumbs = false,
        faderProps = {},
        dimension = {
            width: windowWidth, 
            height: windowHeight, 
            aspectRatio: 16/9
        },
        ...rest

    } = props;

    const handleOnPress = (index) => modalRef?.current.open(index);
    const onIndexChanged = (index) => activeIndexRef.current = index;

    const handleSetIndex = (index) => {
        activeIndexRef.current = index;
        
        if (!showFirst) {
            carouselRef?.current?.scrollTo(index);
        }
    };

    const mediaMap = useMemo(() => media?.map((item, index) => (
        <Pressable onPress={() => handleOnPress(index)}>
            <CarouselItem 
                showPlus={showPlus} 
                thumbnailStyle={thumbnailStyle} 
                thumbnails 
                carouselRef={carouselRef}
                item={item} 
                index={index} 
                dimension={dimension} 
            />
        </Pressable>
    )), [media, dimension, carouselRef, showPlus, thumbnailStyle]);
    
    useImperativeHandle(ref, () => ({
        open: (index) => {
            activeIndexRef.current = index;
            handleOnPress(index);
            carouselRef?.current?.scrollTo(index);
        },
    }), [carouselRef, modalRef]);

    if (media?.length === 0) 
        return (<></>);

    return (
        <>
        
            <View ratio={1} {...rest}>
                <CarouselModal
                    ref={modalRef}
                    media={media}
                    actions={actions}
                    methods={{setActiveIndex: handleSetIndex}}
                    refs={{
                        carouselRef: carouselRef, 
                        activeIndexRef: activeIndexRef
                    }} 
                />
                
                {showFirst &&
                    <Pressable onPress={handleOnPress}>
                        <CarouselItem 
                            showPlus={showPlus} 
                            thumbnailStyle={thumbnailStyle} 
                            carouselRef={carouselRef} 
                            item={media[0]} 
                            index={0}
                            dimension={dimension} 
                        />
                    </Pressable>
                }

                {!showFirst && 
                    <Swiper 
                        loop={false}
                        showsButtons={true}
                        autoplay={false}
                        removeClippedSubviews={true}
                        ref={carouselRef}
                        showsPagination={false}
                        width={dimension?.width}
                        overScrollMode="never" 
                        height={dimension?.height}
                        renderPagination={undefined} //showCounter ? renderPagination : undefined}
                        prevButton={PrevButton}
                        nextButton={NextButton}
                        onIndexChanged={onIndexChanged}
                        >
                        {mediaMap}
                    </Swiper>
                }

            </View>
        </>
    )
})

export default Carousel;